function Footer() {
	return (
		<div className="Footer">
			<span className="FooterElement">The Pirate Phone © 2025</span>
			<span className="FooterElement">
				Un projet de{' '}
				<a target="_blank" href="https://linktr.ee/coordination.etudiante">
					la coordination étudiante
				</a>
			</span>
			<span className="FooterElement">Réalisé avec ❤️ depuis Grenoble</span>
		</div>
	);
}

export default Footer;
